import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, MessageCircle, Clock } from 'lucide-react';
import { WhatsAppLink, WhatsAppMessages } from './WhatsAppChat';

const Footer = () => {
  return (
    <footer className="bg-green-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/logo-cropped.png" alt="NarkOnline" className="h-9 w-9 object-contain brightness-0 invert" />
              <span className="text-xl font-bold">NarkOnline</span>
            </div>
            <p className="text-sm font-semibold text-white mb-2">Nark Online (Pty) Ltd</p>
            <p className="text-green-200 text-sm leading-relaxed mb-4">
              Serving Eersterust and surrounding communities.
            </p>
            <p className="text-green-300 text-xs leading-relaxed">
              All payments are securely processed via Paystack. NarkOnline is the merchant of record 
              and responsible for all transactions, refunds, and customer support.
            </p>
          </div>

          {/* Shop */}
          <div>
            <h4 className="font-semibold mb-4">Shop</h4>
            <ul className="space-y-2 text-sm text-green-200">
              <li><Link to="/products" className="hover:text-white transition-colors">All Products</Link></li>
              <li><Link to="/cart" className="hover:text-white transition-colors">My Cart</Link></li>
              <li><Link to="/orders" className="hover:text-white transition-colors">Track My Order</Link></li>
              <li><Link to="/driver/signup" className="hover:text-white transition-colors">Become a Driver</Link></li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h4 className="font-semibold mb-4">Policies</h4>
            <ul className="space-y-2 text-sm text-green-200">
              <li><Link to="/delivery-policy" className="hover:text-white transition-colors">Delivery Policy</Link></li>
              <li><Link to="/refund-policy" className="hover:text-white transition-colors">Refund Policy</Link></li>
              <li><Link to="/cancellation-policy" className="hover:text-white transition-colors">Cancellation Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-green-200">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <a href="tel:+27615304587" className="hover:text-white">061 530 4587</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href="mailto:admin@narkonline.com" className="hover:text-white">admin@narkonline.com</a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Eersterust, Pretoria<br />Gauteng, South Africa</span>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Mon–Sat: 7am – 6pm<br />Sun: 8am – 2pm</span>
              </li>
              <li className="pt-2">
                <WhatsAppLink 
                  message={WhatsAppMessages.generalSupport()}
                  className="inline-flex items-center gap-2 bg-green-800 hover:bg-green-700 rounded-lg px-3 py-2 text-white text-sm transition-colors"
                >
                  <MessageCircle className="w-4 h-4" />
                  WhatsApp Us
                </WhatsAppLink>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-green-800 mt-10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-green-300">
            &copy; {new Date().getFullYear()} Nark Online (Pty) Ltd. All rights reserved.
          </p>
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-green-400">
            <Link to="/delivery-policy" className="hover:text-white">Delivery</Link>
            <Link to="/refund-policy" className="hover:text-white">Refunds</Link>
            <Link to="/cancellation-policy" className="hover:text-white">Cancellation</Link>
            <Link to="/terms-of-service" className="hover:text-white">Terms</Link>
            <Link to="/privacy-policy" className="hover:text-white">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
